import i18n from "i18next"
import { initReactI18next } from "react-i18next"

const browserLang = navigator.language.slice(0, 2)
const defaultLang = ["ru", "en", "es"].includes(browserLang) ? browserLang : "en"

i18n.use(initReactI18next).init({
  lng: defaultLang,
  fallbackLng: "en",
  resources: {
    ru: {
      translation: {
        login: "Войти",
        register: "Регистрация",
        username: "Имя пользователя",
        password: "Пароль",
        loginSuccess: "Добро пожаловать!",
        registerSuccess: "Регистрация успешна!",
        authError: "Неверный логин или пароль",
        noAccount: "Нет аккаунта? Зарегистрироваться",
        hasAccount: "Уже есть аккаунт? Войти",
        logout: "Выйти",
        movies: "Фильмы",
        addMovie: "Добавить фильм",
        enterTitle: "Введите название",
        enterDescription: "Введите описание",
        enterDirectorName: "Введите имя режиссёра",
        enterYear: "Введите год",
        enterRating: "Введите рейтинг",
        title: "Название",
        description: "Описание",
        director: "Режиссёр",
        year: "Год",
        rating: "Рейтинг",
        save: "Сохранить",
        delete: "Удалить",
        edit: "Редактировать",
        cancel: "Отмена",
        loading: "Загрузка...",
        back: "← Назад",
        fillAll: "Заполни все поля!",
        add: "Добавить",
        allYears: "Все годы",
        allRatings: "Все рейтинги",
        sortBy: "Сортировка",
        movieAdded: "Фильм добавлен!",
        movieDeleted: "Фильм удалён!",
        movieUpdated: "Фильм обновлён!",
        search: "Поиск",
      }
    },
    en: {
      translation: {
        login: "Login",
        register: "Register",
        username: "Username",
        password: "Password",
        loginSuccess: "Welcome!",
        registerSuccess: "Registration successful!",
        authError: "Invalid username or password",
        noAccount: "No account? Register",
        hasAccount: "Already have an account? Login",
        logout: "Logout",
        enterTitle: "Enter title",
        enterDescription: "Enter description",
        enterDirectorName: "Enter director's name",
        enterYear: "Enter year",
        enterRating: "Enter rating",
        movies: "Movies",
        addMovie: "Add movie",
        title: "Title",
        description: "Description",
        director: "Director",
        year: "Year",
        rating: "Rating",
        save: "Save",
        delete: "Delete",
        edit: "Edit",
        cancel: "Cancel",
        loading: "Loading...",
        back: "← Back",
        fillAll: "Please fill all fields!",
        add: "Add",
        allYears: "All years",
        allRatings: "All ratings",
        sortBy: "Sort by",
        movieAdded: "Movie added!",
        movieDeleted: "Movie deleted!",
        movieUpdated: "Movie updated!",
        search: "Search",
      }
    },
    es: {
      translation: {
        login: "Entrar",
        register: "Registrarse",
        username: "Usuario",
        password: "Contraseña",
        loginSuccess: "¡Bienvenida!",
        registerSuccess: "¡Registro exitoso!",
        authError: "Usuario o contraseña incorrectos",
        noAccount: "¿No tienes cuenta? Regístrate",
        hasAccount: "¿Ya tienes cuenta? Entra",
        logout: "Salir",
        enterTitle: "Introduce el título",
        enterDescription: "Introduce la descripción",
        enterDirectorName: "Introduce el nombre del director",
        enterYear: "Introduce el año",
        enterRating: "Introduce la calificación",
        movies: "Películas",
        addMovie: "Añadir película",
        title: "Título",
        description: "Descripción",
        director: "Director",
        year: "Año",
        rating: "Puntuación",
        save: "Guardar",
        delete: "Eliminar",
        edit: "Editar",
        cancel: "Cancelar",
        loading: "Cargando...",
        back: "← Volver",
        fillAll: "¡Rellena todos los campos!",
        add: "Añadir",
        allYears: "Todos los años",
        allRatings: "Todas las puntuaciones",
        sortBy: "Ordenar por",
        movieAdded: "¡Película añadida!",
        movieDeleted: "¡Película eliminada!",
        movieUpdated: "¡Película actualizada!",
        search: "Buscar",
      }
    }
  }
})

export default i18n